// extracted by mini-css-extract-plugin
export var backdropBlur = "_k2-0";
export var contentCard = "_k2-5";
export var frame = "_k2-2";
export var image = "_k2-4";
export var imagePane = "_k2-3";
export var modal = "_k2-1";